export const MAIN_APP = process.env.PUBLIC_URL;
export const LOGIN_PAGE = MAIN_APP + "/login";
export const REMIND_PASS_PAGE = MAIN_APP + "/remindPass";
export const REGISTRATION_PAGE = MAIN_APP + "/registration";
export const REGISTRATION_SUCCESS_PAGE = MAIN_APP + "/registrationSuccess";
export const SALE_MOVIE_PAGE = MAIN_APP + "/";
export const MOVIE_DETAILS_PAGE = MAIN_APP + "/movieDetails";
export const CINEMA_HALL_PAGE = MAIN_APP + "/cinemaHall";
export const FINALIZE_PAGE = MAIN_APP + "/finalize";
export const SALE_FOOD_PAGE = MAIN_APP + "/saleFood";
export const NEWS_PAGE = MAIN_APP + "/news";